jQuery(document).ready(() => {
  require("./util");
  //require("./cookie-consent");
  //require("./components");
  //require("./post-types");
  require("./custom");
});
